<template>
  <div class="cp-article" @click="$emit('click')">
    <div
      class="cp-article-image"
      :style="{
        backgroundImage: 'url(' + image + ')',
      }"
    />
    <div class="cp-article-detail">
      <p :class="['cp-article-title', 'is-size-6', 'has-text-link', 'has-text-left']">
        {{ title }}
      </p>
      <p :class="['cp-article-excerpt', 'is-size-6', 'has-text-grey-dark', 'has-text-left']">
        {{ excerpt }}
      </p>
      <hr :class="['cp-article-divider', 'has-background-primary']" />
      <p :class="['cp-article-see-more', 'has-text-right']">
        <span class="subtitle is-6">{{ $t('article.read.more.button') }}</span>
        <b-icon pack="fas" icon="chevron-right" size="is-small" type="is-primary" />
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Article',
  props: {
    title: {
      type: String,
      required: true,
    },
    excerpt: {
      type: String,
      required: true,
    },
    image: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
$image-height: 140px;
$title-height: 50px;
$excerpt-height: 70px;
$see-more-height: 15px;

.cp-article {
  width: 240px;
  height: calc(#{$image-height + $title-height + $excerpt-height + $see-more-height} + 50px);
  margin-top: 20px;
  cursor: pointer;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin: 10px;
  margin-left: 2px;
  border-radius: 5px;
  box-shadow: 0 15px 20px rgba(0, 0, 0, 0.1), 0 5px 12px rgba(0, 0, 0, 0.1);
  background-color: white;
  top: 0px;
  position: relative;
  transition: top 0.1s ease-out, box-shadow 0.1s ease-out;

  &:hover {
    top: 3px;
    box-shadow: 0 10px 38px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1);
  }

  &:active {
    top: 7px;
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 20px 0px;
  }

  &-image {
    height: $image-height;
    width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }

  &-detail {
    padding: 0.7rem;
  }

  &-title {
    height: $title-height;
    overflow: hidden;
  }

  &-excerpt {
    height: $excerpt-height;
    overflow: hidden;
  }

  &-divider {
    margin-left: auto;
    margin-right: auto;
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  &-see-more {
    height: $see-more-height;
  }
}
</style>
